import { render, staticRenderFns } from "./DetailHistory.vue?vue&type=template&id=07dd7cad&scoped=true"
import script from "./DetailHistory.vue?vue&type=script&lang=js"
export * from "./DetailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd7cad",
  null
  
)

export default component.exports